<p class="ra-label-s content-secondary">{{ 'order.description.hint' | translate }}</p>

<!-- Content -->
<div class="form-group">

    <!-- Description -->
    <ra-input 
        [id]="'input-order-description'"
        [formControl]="formControl"
        [label]="'order.description.label' | translate" 
        [placeholder]="'order.description.placeholder' | translate" 
    />
</div>

<!-- Actions -->
<div class="dialog-actions">
    <ra-button 
        type="primary-outline"
        [id]="'button-cancel-order-description'"
        [label]="'common.cancel' | translate"
        (click)="close.emit()">
    </ra-button>
    
    <ra-button 
        [id]="'button-next-order-description'"
        [type]="'primary'"
        [label]="'order.common.next' | translate"
        (click)="nextStep()">
    </ra-button>
</div>
